/*
 * @Author: Claude
 * @Date: 2025-11-11
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-01-09
 * @Description: Image Generation - Entry Point
 */
import dynamic from 'next/dynamic';
import React from 'react';

import ImageGeneratorSkeleton from '@/3.0/image-generator/_components/image-generator-skeleton';
import DelayedRender from '@/components/DelayRender';
import { withLayout } from '@/utils/withLayout';

const ImageGeneration = dynamic(() => import('../../3.0/image-generator/entry'), {
  ssr: false,
  loading: () => (
    <DelayedRender>
      <ImageGeneratorSkeleton />
    </DelayedRender>
  ),
});

const ImageGenerationPage = () => {
  return (
    <>
      <ImageGeneration />
    </>
  );
};

export default withLayout(ImageGenerationPage);
